
<div class="main-page-content">
  <div class="main-page-content-block" *ngIf="currentItem==null">
    <h1 class="content-heading-font">Permissions</h1>


    <div class="row">
      <div class="col-12  ">
        <p-table #dt1
                 dataKey="ID"
                 [value]="list?.Result"
                 [responsive]="true"
                 [paginator]="true"
                 [rows]="25"
                 [loading]="loadingList"
                 [showCurrentPageReport]="true"
                 currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                 [rowsPerPageOptions]="[10, 25, 50, 100, 1000]"
                 [totalRecords]="list?.FilteredRecords"
                 [lazy]="true"
                 (onLazyLoad)="loadTable($event)"
                 styleClass="p-datatable-sm p-datatable-gridlines p-datatable-striped  "
                 sortMode="multiple">


          <ng-template pTemplate="header">
            <tr>
              <th class="text-end" style="width:120px;"></th>
              <th pSortableColumn="ID" class="text-end d-none d-md-table-cell">
                #
                <p-sortIcon field="ID"></p-sortIcon>
                <p-columnFilter type="numeric" field="ID" display="menu" [showOperator]="false" [showAddButton]="false"></p-columnFilter>
              </th>
              <th pSortableColumn="PermissionType" class="text-start  d-none d-xxl-table-cell">
                Type <p-sortIcon field="PermissionType"></p-sortIcon>
                <p-columnFilter type="text" field="PermissionType" display="menu" [showOperator]="false" [showAddButton]="false"></p-columnFilter>
              </th>
              <th pSortableColumn="Permission" class="text-start">
                Name
                <p-sortIcon field="Permission"></p-sortIcon>
                <p-columnFilter type="text" field="Permission" display="menu" [showOperator]="false" [showAddButton]="false"></p-columnFilter>
              </th>
              <th pSortableColumn="FeatureSwitch" class="text-start  d-none d-md-table-cell">
                Feature <p-sortIcon field="FeatureSwitch"></p-sortIcon>
                <p-columnFilter type="text" field="FeatureSwitch" display="menu" [showOperator]="false" [showAddButton]="false"></p-columnFilter>
              </th>
              <th pSortableColumn="PermissionCategory" class="text-start  d-none d-lg-table-cell">
                Category <p-sortIcon field="PermissionCategory"></p-sortIcon>
                <p-columnFilter type="text" field="PermissionCategory" display="menu" [showOperator]="false" [showAddButton]="false"></p-columnFilter>
              </th>
              <th pSortableColumn="Description" class="text-start d-none d-xl-table-cell">
                Description <p-sortIcon field="Description"></p-sortIcon>
                <p-columnFilter type="text" field="Description" display="menu" [showOperator]="false" [showAddButton]="false"></p-columnFilter>
              </th>
              <th pSortableColumn="OpenToBeAssigned" class="text-start d-none d-xxl-table-cell">
                Open <p-sortIcon field="OpenToBeAssigned"></p-sortIcon>
                <p-columnFilter type="boolean" field="OpenToBeAssigned" matchMode="contains" display="menu" [showMatchModes]="false" [showOperator]="false">
                  <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                    <p-dropdown [options]="[{ name: 'Any', value: '' },{ name: 'No', value: 'false' },{ name: 'Yes', value: 'true' }]" [ngModel]="value" placeholder="Any" (onChange)="filter($event.value)" optionLabel="name" optionValue="value">
                    </p-dropdown>
                  </ng-template>
                </p-columnFilter>
              </th>
              <th pSortableColumn="NavigationLinks" class="text-end d-none d-xxl-table-cell">
                Links <p-sortIcon field="NavigationLinks"></p-sortIcon>
                <p-columnFilter type="numeric" field="NavigationLinks" display="menu" [showOperator]="false" [showAddButton]="false"></p-columnFilter>
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-item>
            <tr>
              <th class="text-end">
                <div class="gap-2 d-block ">
                  <a class="btn btn-sm btn-secondary me-1  " (click)="onRowView(item)" title="Edit Client Permission">
                    <i class="pi pi-folder-open"></i>
                  </a>
                  <a class="btn btn-sm btn-primary me-1 " (click)="onRowEditInit(item)" title="Edit">
                    <i class="pi pi-pen-to-square"></i>
                  </a>
                </div>
              </th>
              <th class="text-end d-none d-md-table-cell">{{ item.ID }}</th>
              <td class=" d-none d-xxl-table-cell">{{ item.PermissionType }}</td>
              <td>
                {{ item.Permission }}
              </td>
              <td class=" d-none d-md-table-cell">{{ item.FeatureSwitch }}</td>
              <td class=" d-none d-lg-table-cell">{{ item.PermissionCategory }}</td>
              <td class=" d-none d-xl-table-cell text-truncate">{{ item.Description }}</td>
              <td class=" d-none d-xxl-table-cell fw-bold">
                <div [ngClass]="{'text-danger': !item.OpenToBeAssigned, 'text-success': item.OpenToBeAssigned}">
                  {{ item.OpenToBeAssigned?'Yes':'No' }}
                </div>
              </td>
              <td class="text-end d-none d-xxl-table-cell">
                <a href="#" [routerLink]="['/navigation/links']" [queryParams]="{permissionID: item.ID}">
                  {{ item.NavigationLinks |  number  }}
                </a>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="paginatorleft">

            <button class="btn btn-primary " (click)="loadTable(null)" title="Refress">
              <i class="pi pi-refresh" [ngClass]="{'pi-spin': loadingList}"></i>
            </button>
            &nbsp;
            <button class="btn btn-primary " (click)="clear(dt1)" title="Clear Filter">
              <i class="pi pi-filter-slash"></i>
            </button>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="8">No items found.</td>
            </tr>
          </ng-template>
        </p-table>



      </div>
    </div>

  </div>

  <div class="main-page-content-block" *ngIf="currentItem!=null">
    <div class="float-end">
      <a class="btn btn-secondary me-2" (click)="onRowView(undefined)">Edit client users and roles</a>
      <a class="btn btn-secondary" (click)="cancel()">View list</a>
    </div>

    <h1 class="content-heading-font">

      #{{currentItem.ID }} - {{currentItem.Permission }}
    </h1>


    <form #itemForm="ngForm" [formGroup]="itemFormGroup">
      <div class="row">
        <div class="col mb-3">
          <label for="DisplayName">Name</label>
          <input class="form-control" name="DisplayName" formControlName="DisplayName" autocomplete="off" [placeholder]="currentItem.Permission" required="required" />
        </div>
      </div>
      <div class="row">
        <div class="col mb-3">
          <label for="Description">Description</label>
          <input class="form-control" name="Description" formControlName="Description" autocomplete="off" placeholder="Description" />
        </div>
      </div>
      <div class="row">
        <div class="col mb-3">
          <label for="PermissionType" [class.div-loading]="loadingPermissionTypes">Type</label>
          <p-dropdown class="form-control" name="PermissionType" formControlName="PermissionType"
                      [options]="permissionTypes" optionValue="ID" optionLabel="PermissionType">

          </p-dropdown>
        </div>
      </div>
      <div class="row">
        <div class="col mb-3" [class.div-loading]="loadingPermissionCategories">
          <label for="PermissionCategory">Category</label>
          <p-dropdown class="form-control" name="PermissionCategory" formControlName="PermissionCategory"
                      [options]="permissionCategories" optionValue="ID" optionLabel="PermissionCategory">

          </p-dropdown>
        </div>
      </div>
      <div class="row">
        <div class="col mb-3" [class.div-loading]="loadingFeatureSwitches">
          <label for="FeatureSwitch">Feature</label>
          <p-dropdown class="form-control" name="FeatureSwitch" formControlName="FeatureSwitch" showClear="true"
                      [options]="featureSwitches" optionValue="ID" optionLabel="FeatureSwitch">

          </p-dropdown>
        </div>
      </div>
      <div class="row">
        <div class="col mb-3">
          <label for="OpenToBeAssigned">Can be assigned to other users even if the logged user does not have it?</label>
          <select class="form-control" name="OpenToBeAssigned" formControlName="OpenToBeAssigned">
            <option value="true">Yes</option>
            <option value="false">No</option>
          </select>
        </div>
      </div>
      <div class="row">
        <div class="col mb-3">
          <label for="NotForRoles">Can be assigned to roles?</label>
          <select class="form-control" name="NotForRoles" formControlName="NotForRoles">
            <option value="true">No</option>
            <option value="false">Yes</option>
          </select>
        </div>
      </div>
      <div class="row">
        <div class="col mb-3">
          <label for="NotForUsers">Can be Assigned to users?</label>
          <select class="form-control" name="NotForUsers" formControlName="NotForUsers">
            <option value="true">No</option>
            <option value="false">Yes</option>
          </select>
        </div>
      </div>

      <div class="row mb-2">
        <div class="col mb-3">
          <div for="NavigationLinks" class="mb-1 align-items-baseline">
            Navigation Links: <button class="ms-2 btn btn-outline-primary   " (click)="addSubItem()" title="Add item" type="button" *ngIf="navigationLinks"><i class="pi pi-plus"></i></button>
          </div>
          <div class="div-loading" *ngIf="loadingNavigationLinks">
            &nbsp;
          </div>
          <ng-container formArrayName="NavigationLinks">
            <ng-container *ngFor="let navigationLinksForm of NavigationLinks.controls; let i = index">
              <table class="w-100 mb-1" [formGroupName]="i">
                <tr>
                  <td>
                    <div class="row g-0">
                      <div class="col-12">
                        <p-autoComplete class="form-control" name="Item" formControlName="Item"
                                        [dropdown]="true"
                                        dropdownMode="current"
                                        [forceSelection]="true"
                                        [suggestions]="filteredNavigationLinks"
                                        (completeMethod)="filterNavigationLink($event)"
                                        [optionLabel]="labelNavigationLink"
                                        autocomplete="off"
                                        minLength="0">
                        </p-autoComplete>
                      </div>
                    </div>
                  </td>
                  <td style="width: 50px;vertical-align:bottom; text-align:right">
                    <button class="btn  btn-outline-danger" (click)="deleteSubItem(i)" title="Remove item" type="button"><i class="pi pi-trash"></i></button>
                  </td>
                </tr>
              </table>
            </ng-container>
          </ng-container>
        </div>
      </div>
      <div class="row">
        <div class="col text-center">
          <button class="btn btn-lg btn-primary" type="submit" id="btnSave" [class.button-loading]="loading" (click)="save()">Save</button>
        </div>
      </div>
    </form>
  </div>
</div>


<p-dialog header="Edit '{{ clientPersmissionItem?.Permission || 'permission' }}' on {{clientItem?.SiteName || 'client' }}" [modal]="true" [(visible)]="clientVisible"
          styleClass="p-dialog-lg"
          >
    <div class="row" *ngIf="!clientItem">
      <div class="col mb-3">
        <label for="clientID">Client</label><br />
        <select [(ngModel)]="clientID" [class.div-loading]="loadingClients" class="form-control">
          <option *ngFor="let client of clients" [ngValue]="client.ID">
            {{client.SiteName}} -  {{client.BusinessName}} {{client.Active?'':'[Inactive]'}}
          </option>
        </select>
      </div>
    </div>
    <form #itemForm="ngForm" [formGroup]="clientAssignedPermissionFormGroup">
      <div class="row mb-2" *ngIf="clientAssignedPermission" style="min-width: 600px;">
        <div class="col-12 col-lg-6 mb-3">
          <div for="ClientAssignedPermissionRoles" class="mb-1 align-items-baseline">
            Roles: <button class="ms-2 btn btn-outline-primary   " (click)="addAssignedPermissionRole()" title="Add item" type="button"
                           *ngIf="!clientAssignedPermission.NotForRoles" ><i class="pi pi-plus"></i></button>
            <i class="pi pi-ban text-danger" *ngIf="clientAssignedPermission.NotForRoles" title="Not For Roles"></i>
          </div>
          <ng-container formArrayName="ClientAssignedPermissionRoles">
            <ng-container *ngFor="let roleForm of ClientAssignedPermissionRoles.controls; let i = index">
              <table class="w-100 mb-1" [formGroupName]="i">
                <tr>
                  <td>
                    <div class="row g-0">
                      <div class="col-12" [class.div-loading]="loadingClientRoles">
                        <p-autoComplete class="form-control" name="Item" formControlName="Item"
                                        [dropdown]="true"
                                        dropdownMode="current"
                                        [forceSelection]="true"
                                        [suggestions]="filteredClientRoles"
                                        (completeMethod)="filterClientAssignedPermissionRoles($event)"
                                        [optionLabel]="labelClientAssignedPermissionRoles"
                                        autocomplete="off"
                                        minLength="0">
                        </p-autoComplete>
                      </div>
                    </div>
                  </td>
                  <td style="width: 50px;vertical-align:bottom; text-align:right">
                    <button class="btn  btn-outline-danger" (click)="deleteAssignedPermissionRole(i)" title="Remove item" type="button"><i class="pi pi-trash"></i></button>
                  </td>
                </tr>
              </table>
            </ng-container>
          </ng-container>
        </div>
        <div class="col-12 col-lg-6 mb-3">
          <div for="ClientAssignedPermissionUsers" class="mb-1 align-items-baseline">
            Users: <button class="ms-2 btn btn-outline-primary   " (click)="addAssignedPermissionUser()" title="Add item" type="button"
                           *ngIf="!clientAssignedPermission.NotForUsers" ><i class="pi pi-plus"></i></button>
                   <i class="pi pi-ban text-danger" *ngIf="clientAssignedPermission.NotForUsers" title="Not For Users"></i>
          </div>
          <ng-container formArrayName="ClientAssignedPermissionUsers">
            <ng-container *ngFor="let userForm of ClientAssignedPermissionUsers.controls; let i = index">
              <table class="w-100 mb-1" [formGroupName]="i">
                <tr>
                  <td>
                    <div class="row g-0">
                      <div class="col-12" [class.div-loading]="loadingClientUser">
                        <p-autoComplete class="form-control" name="Item" formControlName="Item"
                                        [dropdown]="true"
                                        dropdownMode="current"
                                        [forceSelection]="true"
                                        [suggestions]="filteredClientUser"
                                        (completeMethod)="filterClientAssignedPermissionUsers($event)"
                                        [optionLabel]="labelClientAssignedPermissionUser"
                                        autocomplete="off"
                                        dataKey="ID"
                                        minLength="0">
                        </p-autoComplete>
                      </div>
                    </div>
                  </td>
                  <td style="width: 50px;vertical-align:bottom; text-align:right">
                    <button class="btn  btn-outline-danger" (click)="deleteAssignedPermissionUser(i)" title="Remove item" type="button"><i class="pi pi-trash"></i></button>
                  </td>
                </tr>
              </table>
            </ng-container>
          </ng-container>
        </div>
     
      </div>
      <div class="row mb-5">
        <div class="col text-center">
          <button class="btn btn-lg btn-primary" type="submit" id="btnClientAssignedPermissionSelect" [class.button-loading]="loading" (click)="clientSelect()" *ngIf="!clientItem">Load client users and roles</button>
          <button class="btn btn-lg btn-primary" type="submit" id="btnClientAssignedPermissionSave" [class.button-loading]="loading" (click)="clientSavePermission()" *ngIf="clientAssignedPermission">Save client users and roles</button>
          <button class="btn btn-lg btn-secondary ms-2" type="button" id="btnClientAssignedPermissionCancel" [class.button-loading]="loading" (click)="clientVisible=false">Cancel</button>
        </div>
      </div>
    </form>
</p-dialog>
